import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { SapPlantService } from '../proxy/controlling/controllers/sap-plant.service';

FieldBuilder.setNamespace('Controlling');

export const STORAGELOCATION_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.StorageLocation.Name')
    .required()
    .minLength(1)
    .maxLength(200)
    .build(),
  FieldBuilder
    .text('sapCode', 'Entity.StorageLocation.SapCode')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
  FieldBuilder
    .foreignKey('sapPlantId', 'Entity.Plant', SapPlantService)
    .required()
    .displayFromNested('sapPlant.name')
    .sortBy('sapPlant.name')
    .build(),
];

export const STORAGELOCATION_CONFIG = {
  entityName: 'StorageLocation',
  localizationKey: 'Controlling::Entity.StorageLocation',
  fields: STORAGELOCATION_FIELDS,
  permission: 'ControllingSap.StorageLocations',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
